import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["frame"];

  fetch(event) {
    this.frameTarget.src = event.currentTarget.dataset.url;
  }
}
